import { styled } from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const Title = styled.h2`
  font-size: var(--font-size-baseline);
  font-weight: var(--font-bold);
  margin-bottom: var(--spacing-tiny);
  margin-top: var(--spacing-medium);
`;

export const ActionButton = styled.a`
  color: var(--color-link);
  font-weight: var(--font-semibold);
  margin-top: var(--spacing-small);

  @media (hover: hover) {
    &:hover {
      text-decoration: underline;
    }
  }
`;
